import React from 'react';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';
import chevron from '../../../ASUPhotos/icons/chevron.svg';

const fillColoring = {
  fillColor: (props) => ({
    background: props.fillColor,
  }),
};

function SwitchCareerIndicator(props) {
  const { chevronClickHandlerParent, currentCareer } = { ...props };
  const { t } = useTranslation();

  const handleChevronClicked = (direction) => {
    chevronClickHandlerParent(direction);
  };

  return (
    <div
      className={[
        'switch-career-indicator-container',
        props.classes.fillColor,
      ].join(' ')}
    >
      <button
        className="left-chevron"
        tabIndex={0}
        alt="chevron"
        style={{ backgroundImage: `url(${chevron})` }}
        onClick={() => handleChevronClicked('left')}
        type="button"
        aria-label={t(
          'Button. Click or press enter to toggle through your top 3 careers. Your current selection is {{currentCareer}} and you have placed {{numberClasses}} of {{numberRequired}} classes for this path.',
          {
            currentCareer,
            numberClasses: props.classesPlaced,
            numberRequired: props.classesRequired,
          }
        )}
      />
      <p className="switch-career-text">{t('Switch Career Choice')}</p>
      <button
        className="right-chevron"
        alt="chevron"
        tabIndex={0}
        style={{ backgroundImage: `url(${chevron})` }}
        onClick={() => handleChevronClicked('right')}
        type="button"
        aria-label={t(
          'Button. Click or press enter to toggle through your top 3 careers. Your current selection is {{currentCareer}} and you have placed {{numberClasses}} of {{numberRequired}} classes for this path.',
          {
            currentCareer,
            numberClasses: props.classesPlaced,
            numberRequired: props.classesRequired,
          }
        )}
      />
    </div>
  );
}

export default withStyles(fillColoring)(SwitchCareerIndicator);
